export default {
  INTERNAL: 'Something went wrong',
  NOT_AUTHORIZATION: 'Unauthorized',
  NOT_LOGIN: 'Unauthorized',
};
